<template>
  <div class="columns is-multiline">
        <div class="column is-12 is-8-desktop">
            <div class="columns is-multiline">
                <div class="column is-12">
                        <div class="columns">
                            <div class="column is-12 is-6-desktop">
                                <h3 class="is-uppercase is-size-6 has-text-weight-bold">Buchungsjahr {{selected}} Gesamt</h3>
                            </div>
                            <div class="column is-12 is-6-desktop">
                                <select name="yearSelect" id="" v-model="selected" @change="yearSelected">
                                    <option :value="year" v-for="year of saldo['allyears']" v-bind:key="parseInt(year)" :selected="(parseInt(year) == parseInt(selected)) ? 'true' : 'false'">{{year}}</option>
                                </select>
                            </div>
                        </div>
                </div>
                    <div class="column is-4">
                        <h4 class="is-uppercase">Einnahmen (brutto)</h4>
                    <p class="is-size-5" :class="(apiSaldo === null) ? ((saldo['income'] > 0) ? 'has-text-success' : ''): ((apiSaldo.income > 0) ? 'has-text-success' : '')">€ {{ (apiSaldo === null) ? (saldo['income_formatted']) : apiSaldo.income_formatted }}</p>
                    </div>
                    <div class="column is-4">
                        <h4 class="is-uppercase">Ausgaben (brutto)</h4>
                        <p class="is-size-5" :class="(apiSaldo === null) ? ((saldo['expense'] > 0) ? 'has-text-danger' : ''): ((apiSaldo.expense > 0) ? 'has-text-danger' : '')">€ {{ (apiSaldo === null) ? (saldo['expense_formatted']) : apiSaldo.expense_formatted }}</p>
                    </div>
                    <div class="column is-4">
                        <h4 class="is-uppercase">Saldo (brutto)</h4>
                        <p class="is-size-5" :class="(apiSaldo === null) ? ((saldo['saldo'] > 0) ? 'has-text-success' : 'has-text-danger') : ((apiSaldo.saldo > 0) ? 'has-text-success' : 'has-text-danger')">€ {{ (apiSaldo === null) ? saldo['saldo_formatted'] : apiSaldo.saldo_formatted }}</p>
                    </div>
                </div>
        </div>
        <div class="column is-12 is-4-desktop"><ck-saldo-chart height="150" :chartdata="(apiSaldo !== null) ? apiSaldo : JSON.stringify(saldo)"></ck-saldo-chart></div>
    </div>
</template>

<script>
import vue from 'vue';
import ckSaldoChart from './charts/ckSaldoChart.vue'

export default {
    components: {
        ckSaldoChart
    },
    props: ['originalSaldo', 'year', 'player'],
    data: function() {
        return {
            saldo: JSON.parse(this.originalSaldo),
            selected: JSON.parse(this.originalSaldo)['year'],
            apiSaldo: null
        }
    },
    methods: {
        yearSelected: function() {
            if (this.player) {
                return axios.get(`/accountingperplayer/${this.player}/peryear/${this.selected}/`).then(res => {
                    console.log(res.data);
                    this.apiSaldo = res.data;
                    this.selected = res.data['year'];
                }).catch(err => console.log(err))
            }

            axios.get(`/accountingperyear/${this.selected}`).then(res => {
                console.log(res.data);
                this.apiSaldo = res.data;
                this.selected = res.data['year'];
            }).catch(err => console.log(err))
        }
    },
    computed: {
    },
    mounted: function() {
        console.log(this.saldo)
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckSaldoWidget.vue